import { render } from "./OrderableAdvancedTable.vue?vue&type=template&id=046c264e&scoped=true&ts=true"
import script from "./OrderableAdvancedTable.vue?vue&type=script&lang=ts"
export * from "./OrderableAdvancedTable.vue?vue&type=script&lang=ts"

import "./OrderableAdvancedTable.vue?vue&type=style&index=0&id=046c264e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046c264e"]])

export default __exports__